import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  LessonInput,
  LESSON_TYPES,
  lessonsSelector,
  setLiveLecture,
} from 'features/classCreation';
import DiscussionSwitch from '../DiscussionSwitch';
import Field from 'components/Field';
import LectureContentInputGroup from '../LectureContentInputGroup';

function Discussion({ errors }) {
  const dispatch = useDispatch();
  const lessons = useSelector(lessonsSelector);

  const handleDiscussionChange = useCallback(
    (option) => {
      dispatch(setLiveLecture(option));
    },
    [dispatch]
  );

  return (
    <>
      <div className="row align-c dark bold m-b-l">
        Discussion <DiscussionSwitch />
      </div>
      {lessons.live_lecture && (
        <>
          <Field
            label="Discussion Duration"
            className="m-b-l"
            serverErrors={errors}
            name={LESSON_TYPES.liveLecture}
          >
            <LessonInput
              lessonType={LESSON_TYPES.liveLecture}
              value={lessons.liveLecture}
              onChange={handleDiscussionChange}
              placeholder="Enter Discussion Duration"
            />
          </Field>
          <LectureContentInputGroup errors={errors} />
        </>
      )}
    </>
  );
}

export default Discussion;
